import script from "./Ruler.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ruler.vue?vue&type=script&lang=ts&setup=true"

import "./Ruler.vue?vue&type=style&index=0&id=2963c74c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2963c74c"]])

export default __exports__